import { User } from '../../maintenance/model/user';
import { UsersService } from '../../services/users.service';
import { getUserInfo } from '../../util/auth/helpers';

let statusHeader = false, statusAddpage = false, statusDeletePage = false,
 statusAddContenido = false, statusAddClause = false, statusRemoveSignature = false,
 statusSignatureMade = false, statusAddSignature = false, statusTypeHeader = false,
 statusNameHeader = false, statusFechHeader = false, statusDate1Header = false, 
 statusDate2Header = false, statusLogoHeader = false, statusDeleteLogoHeader = false, 
 statusNameSignature = false, statusCargoSignature = false, statusDeleteSignature = false,
 statusFechSignature = false, statusImageSignature = false, statusAddFile = false, statusAddCollaborator = false;
 let arrayChanges=[]

 let descriptionEnd: string 

 let name: string
 let nameFile
 export function getNameFIle(name) {
  return nameFile = name[0].name;
}

export function toInteger(value: any): number {
  return parseInt(`${value}`, 10);
}

export function toString(value: any): string {
  return (value !== undefined && value !== null) ? `${value}` : '';
}

export function getValueInRange(value: number, max: number, min = 0): number {
  return Math.max(Math.min(value, max), min);
}

export function isString(value: any): value is string {
  return typeof value === 'string';
}

export function isNumber(value: any): value is number {
  return !isNaN(toInteger(value));
}

export function isInteger(value: any): value is number {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

export function isDefined(value: any): boolean {
  return value !== undefined && value !== null;
}

export function padNumber(value: number) {
  if (isNumber(value)) {
    return `0${value}`.slice(-2);
  } else {
    return '';
  }
}

export function regExpEscape(text) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

export function hasClassName(element: any, className: string): boolean {
  return element && element.className && element.className.split &&
      element.className.split(/\s+/).indexOf(className) >= 0;
}

export function getTime(){

    let date = new Date()
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    let newMinutes = minutes < 10 ? '0'+minutes : minutes;
    let strTime = hours + ':' + newMinutes + ' ' + ampm;
    return strTime;

}

export function spliceSlice(str: string, index: number, count: number, add: string) {
  if (index < 0) {
    index = str.length + index
    if (index < 0) {
      index = 0
    }
  }
  return str.slice(0, index) + (add || "") + str.slice(index + count)
}

export function saveChange( option:String, userName:String, dynamic, time) {
  
  let description : string

  if(option === "notChange"){
    statusHeader = false
    statusAddpage = false
    statusDeletePage = false,
    statusAddContenido = false
    statusRemoveSignature = false
    statusSignatureMade = false
    statusAddSignature = false
    statusTypeHeader = false
    statusNameHeader = false
    statusFechHeader = false
    statusDate1Header = false 
    statusDate2Header = false
    statusLogoHeader = false
    statusDeleteLogoHeader = false 
    statusNameSignature = false
    statusCargoSignature = false
    statusDeleteSignature = false
    statusFechSignature = false
    statusImageSignature = false
    statusAddFile = false
    statusAddCollaborator = false
    descriptionEnd =""
    description = "  "
    arrayChanges = []

  }else if(option === "addPage" && !statusAddpage){
    statusAddpage = true
    description =  `-(${time}):` + " Se agregó nuevas páginas.#" 
    arrayChanges.push(description);
    descriptionEnd = descriptionEnd + description
  }else if(option === "deletePage" && !statusDeletePage){
    statusDeletePage = true,
    description =  `-(${time}):` + " Se eliminó página en el documento.#"
    arrayChanges.push(description);
    descriptionEnd = descriptionEnd + description

  }else if(option === "addContenido" && !statusAddContenido){
    statusAddContenido = true
    description = `-(${time}):` + " Se agregó nuevo contenido.#"
    arrayChanges.push(description);
    descriptionEnd = descriptionEnd + description

  }else if(option === "addClause"){
    if(dynamic){
      description = `-(${time}):` + ' Se agregó cláusula "' + dynamic + '".#'
      arrayChanges.push(description);
      descriptionEnd = descriptionEnd + description
    }

   }else if(option === "removeSignatures"){
    description = `-(${time}):` + " Se eliminó firmante.#" 
    arrayChanges.push(description);
    descriptionEnd = descriptionEnd + description

  }else if(option === "signatureMade" && !statusSignatureMade){
    statusSignatureMade = true
    description = `-(${time}):` + " Se realizó firma.#"
    arrayChanges.push(description);
    descriptionEnd = descriptionEnd + description

  }else if(option === "addSignature"){
    description = `-(${time}):` + " Se agregó nueva sección de firma.#"
    arrayChanges.push(description);
    descriptionEnd = descriptionEnd + description

  }else if(option === "typeHeader" && !statusTypeHeader){
    statusTypeHeader = true
    description = `-(${time}):` + " Se cambio el tipo de encabezado.#"
    arrayChanges.push(description); 
    descriptionEnd = descriptionEnd + description

  }else if(option === "nameHeader" && !statusNameHeader){
    statusNameHeader = true
    description = `-(${time}):` + " Se agregó nombre en el encabezado.#"
    arrayChanges.push(description);
    descriptionEnd = descriptionEnd +  description

  }else if(option === "fechHeader" && !statusFechHeader){
    statusFechHeader = true
    description = `-(${time}):` + " Se agregó la fecha en el encabezado.#"
    arrayChanges.push(description);
    descriptionEnd = descriptionEnd +  description

  }else if(option === "date1Header" && !statusDate1Header){
    statusDate1Header = true 
    description = `-(${time}):` + " Se agregó el dato 1 en el encabezado.#" 
    arrayChanges.push(description);
    descriptionEnd = descriptionEnd  + description

  }else if(option === "date2Header" && !statusDate2Header){
    statusDate2Header = true
    description = `-(${time}):` + " Se agregó el dato 2 en el encabezado.#"
    arrayChanges.push(description);
    descriptionEnd = descriptionEnd + description

  }else if(option === "logoHeader" && !statusLogoHeader){
    statusLogoHeader = true
    description = `-(${time}):` + " Se agregó logo en el encabezado.#" 
    arrayChanges.push(description);
    descriptionEnd = descriptionEnd  + description

  }else if(option === "deleteLogoHeader" && !statusDeleteLogoHeader){
    statusDeleteLogoHeader = true
    description = `-(${time}):` + " Se eliminó logo en el encabezado.#"
    arrayChanges.push(description); 
    descriptionEnd = descriptionEnd + description

  }else if(option === "nameSignature" && !statusNameSignature){
    statusNameSignature = true
    description = `-(${time}):` + " Se agregó nombre en firmante.#"
    arrayChanges.push(description);
    descriptionEnd = descriptionEnd + description

  }else if(option === "CargoSignature" && !statusCargoSignature){
    statusCargoSignature = true
    description = `-(${time}):` + " Se agregó cargo en firmante.#"
    arrayChanges.push(description);
    descriptionEnd = descriptionEnd + description

  }else if(option === "deleteSignature"){
    description = `-(${time}):` + " Se eliminó firmante.#"
    arrayChanges.push(description);
    descriptionEnd = descriptionEnd + description

  }else if(option === "fechSignature" && !statusFechSignature){
    statusFechSignature = true
    description = `-(${time}):` + " Se agregó fecha en firmante.#"
    arrayChanges.push(description);
    descriptionEnd = descriptionEnd + description

  }else if(option === "imageSignature" && !statusImageSignature){
    statusImageSignature = true
    description = `-(${time}):` + " Se agregó firma por medio de imagen.#" 
    arrayChanges.push(description);
    descriptionEnd = descriptionEnd + description

  }else if(option === "addFile"){
    description = `-(${time}):` + " Se inserto documento" + ` "${nameFile}".#`
    arrayChanges.push(description);
    descriptionEnd = descriptionEnd + description
  }else if(option === "addCollaborator" && !statusAddCollaborator){
    name = undefined
     dynamic.map(function(obj){
       if(name === undefined){
        name = obj
       }else{
        name = name + ", " + obj
       }
   });

    description = `-(${time}):` + " Se agregó colaborador al documento "+"("+name+").#" 
    arrayChanges.push(description);
    descriptionEnd = descriptionEnd + description
  }else if(option === "sendEmail"){
    description = `-(${time}):` + " Se envio a firmar al correo (" + dynamic + ").#"
    arrayChanges.push(description);
    descriptionEnd = descriptionEnd + description
  }else if(option === "deleteSection"){
    if(dynamic){
      description = `-(${time}):` + ' Se elimino la cláusula "' + dynamic + `.#`
      arrayChanges.push(description);
      descriptionEnd = descriptionEnd + description
    }else{
      description = `-(${time}):` + " Se elimino contenido.#"
      arrayChanges.push(description);
      descriptionEnd = descriptionEnd + description
    }

  }else if(option === "addContendHeader"){
    description = `-(${time}):` + " Se editó el encabezado.#"
    arrayChanges.push(description);
    descriptionEnd = descriptionEnd + description
  }else if(option === "editSection"){
    if(dynamic){
      description = `-(${time}):` + ' Se editó la cláusula "' + dynamic + `.#`
      arrayChanges.push(description);
      descriptionEnd = descriptionEnd + description
    }
  }
  if(option != "notChange"){
    description = descriptionEnd
  }
 

  const version = {
    date: new Date(),
    number: 1,
    description: description,
    descriptionArray:arrayChanges,
    status:option,
    name: userName,
  };
  
  let lastChange = []
  lastChange.push(version);
  
  return lastChange;
  
}